import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

class ScrollAnimation {
  constructor(){
    ScrollTrigger.batch(".fade-in", {
      onEnter: (batch) =>
        gsap.to(batch, { opacity: 1, duration: 1, ease: "power1.out" }),
      start: "top 80%",
      once: true,
      markers: false,
    });

    window.addEventListener("load", () => {
      ScrollTrigger.refresh();
    });
  }
}

export default ScrollAnimation;